import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcWorkflows = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12.5 4.75a.25.25 0 0 0-.25.25v6.25h8.5V5a.25.25 0 0 0-.25-.25h-8Zm8.25 8h-8.5V19c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-6.25Zm-10 0V19c0 .966.784 1.75 1.75 1.75h8A1.75 1.75 0 0 0 22.25 19V5a1.75 1.75 0 0 0-1.75-1.75h-8A1.75 1.75 0 0 0 10.75 5v6.25H2.5v1.5h8.25Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M5 12a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Zm5.97-2.97a.75.75 0 0 1 1.06 0l2.44 2.44a.75.75 0 0 1 0 1.06l-2.44 2.44a.75.75 0 0 1-1.06 0l-2.44-2.44a.75.75 0 0 1 0-1.06l2.44-2.44ZM19 10.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-2.5Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M14 18.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-2.5Zm-5-16A.75.75 0 0 1 9.75 2h3.5a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-.75.75h-3.5A.75.75 0 0 1 9 5.25v-2.5Z",
  fill: "var(--mds-nav-icon-medium)"
})), "IcWorkflows");

export { IcWorkflows };
//# sourceMappingURL=ic-workflows.js.map
